import { gql } from 'graphql-request'

export const EXPORT_COIN_SUMMARY = gql`
  query ExportCoinSummary($startDate: DateTime!, $endDate: DateTime!) {
    exportCoinSummary(startDate: $startDate, endDate: $endDate)
  }
`
